export const handlePopupDisplayReducer = (state = {data: {id:null,shouldDisplay:false}}, action) => {
    if (action.type === 'POPUP_HANDLER') {
        return {
            data: action.payload
        }
    }
    return state;
};
